import React from "react";
import { Card, Table, Typography, Tag, Button, Empty } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { ProposalModel } from "../model/proposals.ui";
import { getStatusConfig, formatDisplayDate } from "./proposalHelpers";
import { DesktopPagination } from "../../orders/components/DesktopPagination";
import { ProposalDesktopPagnination } from "./ProposalDesktopPagnination";

const { Text } = Typography;

export interface ProposalDesktopTableProps {
  proposals: ProposalModel[];
  isLoading: boolean;
  currentPage: number;
  totalPages: number;
  totalItems?: number;
  onPageChange?: (page: number) => Promise<void>;
  onSelectProposal: (proposal: ProposalModel) => void;
}

export const ProposalDesktopTable: React.FC<ProposalDesktopTableProps> = ({
  proposals,
  isLoading,
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  onSelectProposal,
}) => {
  const desktopColumns = [
    {
      title: "提案番号", // Mã đề xuất
      dataIndex: "propose_code",
      key: "propose_code",
      render: (text: string) => <Text strong>{text || "-"}</Text>,
    },
    {
      title: "受取人", // Người nhận
      dataIndex: "recipient_name",
      key: "recipient_name",
      render: (text: string | null) => <Text>{text || "-"}</Text>,
    },
    {
      title: "担当者ID", // ID người phụ trách
      dataIndex: "representative_id",
      key: "representative_id",
      render: (text: string) => <Text type="secondary">{text || "-"}</Text>,
    },
    {
      title: "有効期間", // Thời gian hiệu lực
      key: "effective",
      render: (_: unknown, record: ProposalModel) => (
        <Text style={{ fontSize: 13 }}>
          {formatDisplayDate(record.effective_from)} ～{" "}
          {formatDisplayDate(record.effective_to)}
        </Text>
      ),
    },
    {
      title: "ステータス", // Trạng thái
      dataIndex: "status",
      key: "status",
      render: (status: string) => {
        const info = getStatusConfig(status);
        return (
          <Tag color={info.color} icon={info.icon}>
            {info.label}
          </Tag>
        );
      },
    },
    {
      title: "操作", // Thao tác
      key: "action",
      render: (_: unknown, record: ProposalModel) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => onSelectProposal(record)}
        >
          詳細 {/* Chi tiết */}
        </Button>
      ),
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        backgroundColor: "white",
        borderRadius: 16,
        boxSizing: 'border-box'
      }}
    >

      <Table
        dataSource={proposals}
        columns={desktopColumns}
        rowKey={(r) => String(r.propose_id || r.propose_code || Math.random())}
        pagination={false}
        loading={isLoading}
        sticky
        locale={{ emptyText: <Empty description="提案がありません" /* Không có đề xuất */ /> }}
      />

      {onPageChange && (
        <ProposalDesktopPagnination
          currentPage={currentPage}
          totalPages={totalPages}
          isLoading={isLoading}
          onPageChange={onPageChange}
        />
      )}

    </div>
  );
};
